module.exports = {"511723100":"新宁镇","511723101":"普安镇","511723102":"回龙镇","511723103":"天师镇","511723104":"永兴镇","511723105":"讲治镇","511723106":"甘棠镇","511723107":"任市镇","511723108":"广福镇","511723109":"长岭镇","511723110":"八庙镇","511723111":"灵岩镇","511723112":"宝石镇","511723200":"长田乡","511723201":"骑龙乡","511723202":"新太乡","511723204":"沙坝场乡","511723205":"梅家乡","511723207":"靖安乡","511723208":"新街乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511723.json
// module id = 2375
// module chunks = 0